export default "__VITE_ASSET__D9bX8DkM__"